import { render, staticRenderFns } from "./HighscoreTab.vue?vue&type=template&id=321c3920&"
import script from "./HighscoreTab.vue?vue&type=script&lang=ts&"
export * from "./HighscoreTab.vue?vue&type=script&lang=ts&"
import style0 from "./HighscoreTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports